import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=bd5e653e&scoped=true"
import script from "./MobileMenu.vue?vue&type=script&lang=ts"
export * from "./MobileMenu.vue?vue&type=script&lang=ts"
import style0 from "./MobileMenu.vue?vue&type=style&index=0&id=bd5e653e&prod&lang=scss&scoped=true"
import style1 from "./MobileMenu.vue?vue&type=style&index=1&id=bd5e653e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@4.3.0_lodash@4.17.21_prettier@2.8.8_react-dom@18.3.1_react@17.0_5ioacul63gvtxmolb2qhpey7py/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5e653e",
  null
  
)

export default component.exports